export function lerp(start: number, end: number, t: number = 0.075): number {
    return start * ( 1 - t ) + end * t
}